import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import { SpendReportModel } from "@waytek/Types/SpendReport";
import { Draft } from "immer";

export interface CustomSpendReportingStateType {
    readonly isLoading: boolean;
    readonly yearSelected: number;
    readonly spendReport: { [key: string]: SpendReportModel };
    readonly yearToDateValue?: string;
}

export type CustomSpendReportingState = Readonly<CustomSpendReportingStateType>;

export const initialSpendReportingState: CustomSpendReportingState = {
    isLoading: true,
    yearSelected: new Date().getFullYear(),
    spendReport: {},
};

export const customSpendReportingReducer = createTypedReducer(initialSpendReportingState, {
    "Custom/SpendReportingState/SetIsLoading": (
        draft: Draft<CustomSpendReportingState>,
        { isLoading }: { isLoading: boolean },
    ) => ({
        ...draft,
        isLoading,
    }),
    "Custom/SpendReportingState/SetYearSelected": (
        draft: Draft<CustomSpendReportingState>,
        { yearSelected }: { yearSelected: number },
    ) => ({
        ...draft,
        yearSelected,
    }),
    "Custom/SpendReportingState/SetSpendReportData": (
        draft: Draft<CustomSpendReportingState>,
        { key, spendReport }: { key: string; spendReport: SpendReportModel },
    ) => ({
        ...draft,
        spendReport: {
            ...draft.spendReport,
            [key]: spendReport,
        },
        yearToDateValue: spendReport.yearToDateSalesDisplay,
    }),
});
